class RoutesPath {
    static HOME = { NAME: 'Home', PATH: '/' };
    
    static SETUP = { NAME: 'Setup', PATH: '/setup' };

    static EXAMPLE_PAGE = { NAME: 'Example Page', PATH: '/example' };
}

export default RoutesPath;
